/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable, ApplicationRef } from '@angular/core';
import { IceNavService } from '../../../../projects/icemedx-lib/src/components/ice-nav/ice-nav.service';
import { BaseAppService } from '../../../../projects/icemedx-lib/src/services/baseapp.service';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';
import { LoginService } from 'projects/icemedx-lib/src/login/login.service';
import { BreadcrumbService } from '../../../icemedx-lib/src/services/breadcrumb/breadcrumb.service';

@Injectable()
export class AppService extends BaseAppService {

  constructor(navSvc: IceNavService, domainSvc: DomainService, loginSvc: LoginService, app: ApplicationRef, breadcrumbSvc: BreadcrumbService) {
    super(navSvc, domainSvc, loginSvc, app, breadcrumbSvc);
  }

  public defaultMenus() {
    super.defaultMenus();
    super.networkMenu();
  }
}
